
//Mandatory Fields Configuration.
export const DEFAULT_OPCO = Object.freeze({
        phone_number: 'true',
        given_name: 'false',
        middle_name: 'false',
        family_name: 'false',
        address_country: 'false',
        address_street_address: 'false',
        address_locality: 'false',
        address_postal_code: 'false',
        address_region: 'false',
        kyc_personal_id_id_type: 'true',
        kyc_personal_id_id_number: 'true',
        kyc_personal_id_issue_date: 'false',
        kyc_personal_id_expiration_date: 'false',
        birthdate: 'false',
        birthplace: 'false',
        kyc_fiscal_code: 'false',
        kyc_nationality: 'false',
        kyc_pid_type_name: ['Passport','National ID'],
        kyc_pid_type_value: ['PASSPORT','ID_CARD']
});

export const SPAIN = Object.freeze({
    phone_number: 'true',
    given_name: 'false',
    middle_name: 'false',
    family_name: 'false',
    address_country: 'false',
    address_street_address: 'false',
    address_locality: 'false',
    address_postal_code: 'false',
    address_region: 'false',
    kyc_personal_id_id_type: 'true',
    kyc_personal_id_id_number: 'true',
    kyc_personal_id_issue_date: 'false',
    kyc_personal_id_expiration_date: 'false',
    birthdate: 'false',
    birthplace: 'false',
    kyc_fiscal_code: 'false',
    kyc_nationality: 'false',
    kyc_pid_type_name: ['Passport','National ID'],
    kyc_pid_type_value: ['PASSPORT','ID_CARD']
});

export const ITALY = Object.freeze({
    phone_number: 'true',
    given_name: 'false',
    middle_name: 'false',
    family_name: 'false',
    address_country: 'false',
    address_street_address: 'false',
    address_locality: 'false',
    address_postal_code: 'false',
    address_region: 'false',
    kyc_personal_id_id_type: 'true',
    kyc_personal_id_id_number: 'true',
    kyc_personal_id_issue_date: 'false',
    kyc_personal_id_expiration_date: 'true',
    birthdate: 'false',
    birthplace: 'true',
    kyc_fiscal_code: 'true',
    kyc_nationality: 'true',
    kyc_pid_type_name: ['Passport','National ID'],
    kyc_pid_type_value: ['PASSPORT','ID_CARD']
});


export const GERMANY = Object.freeze({
    phone_number: 'true',
    given_name: 'false',
    middle_name: 'false',
    family_name: 'false',
    address_country: 'false',
    address_street_address: 'false',
    address_locality: 'false',
    address_postal_code: 'false',
    address_region: 'false',
    kyc_personal_id_id_type: 'true',
    kyc_personal_id_id_number: 'true',
    kyc_personal_id_issue_date: 'true',
    kyc_personal_id_expiration_date: 'true',
    birthdate: 'false',
    birthplace: 'false',
    kyc_fiscal_code: 'false',
    kyc_nationality: 'false',
    kyc_pid_type_name: ['Passport','National ID'],
    kyc_pid_type_value: ['PASSPORT','ID_CARD']
});


export const UK = Object.freeze({
    phone_number: 'true',
    given_name: 'false',
    middle_name: 'false',
    family_name: 'false',
    address_country: 'false',
    address_street_address: 'false',
    address_locality: 'false',
    address_postal_code: 'false',
    address_region: 'false',
    kyc_personal_id_id_type: 'false',
    kyc_personal_id_id_number: 'false',
    kyc_personal_id_issue_date: 'false',
    kyc_personal_id_expiration_date: 'false',
    birthdate: 'false',
    birthplace: 'false',
    kyc_fiscal_code: 'false',
    kyc_nationality: 'false',
    kyc_pid_type_name: ['Passport','National ID',"Driving licence"],
    kyc_pid_type_value: ['PASSPORT','ID_CARD',"DRIVING_LICENSE"]
});

export const COUNTRY_CODE = Object.freeze({
    country_code: ['de', 'es', 'gb', 'it', 'nl']
});

export const ALL_COUNTRY_CODE = Object.freeze({
    country_codes: ['al', 'au', 'cz', 'de', 'eg', 'es', 'gb', 'gr', 'hu', 'ie', 'in', 'is', 'it', 'mt', 'nl', 'nv', 'nz', 'pt', 'ro', 'ru', 'tr', 'us', 'za']
});

export const DISPLAY_KYC_PERSONAL_IDTYPE = Object.freeze({
    kyc_pid_type_display_name: ['Passport','National ID',"Driving licence"],
    kyc_pid_type_display_value: ['PASSPORT','ID_CARD',"DRIVING_LICENSE"]
});


// WEBPACK FOOTER //
// ./src/app/_constants/config.ts